import { useState, useEffect  } from 'react';
import VideoForm from './VideoForm';
import { colors, modal as S, field, btn } from './styles';

const emptyForm = () => ({
  title: '', videoLink: '', language: '', bookId: '',
  author: '', lesson: '', description: '', tags: '', chapters: '',
    translator: '', videoType:'',
  isPublished: false, // ← add
});

function buildBody(form) {
  return {
    title:       form.title.trim(),
    videoLink:   form.videoLink.trim(),
    language:    form.language.trim(),
    lesson:      form.lesson.trim(),
    description: form.description.trim(),
    author:      form.author.trim(),
    bookId:      parseInt(form.bookId) || 0,
    tags:        form.tags.trim(),
    chapters:    form.chapters.trim(),
      translator: form.translator.trim(),
      videoType: form.videoType,
    isPublished: !!form.isPublished,  // ← add
  };
}

/**
 * CreateVideo
 * Props:
 *   onSave(body)  - async fn that POSTs the video; throws on error
 *   onClose()     - closes the modal
 */
export default function CreateVideo({ onSave, onClose }) {
  const [form, setForm]     = useState(emptyForm());
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  const handleChange = (key, value) => setForm(f => ({ ...f, [key]: value }));

  const validate = () => {
    if (!form.title.trim())    return 'Title is required.';
    if (!form.videoLink.trim()) return 'Video Link is required.';
    if (!form.bookId)           return 'Book ID is required.';
    return '';
  };

  const handleSave = async () => {
    const err = validate();
    if (err) { setError(err); return; }
    setSaving(true);
    setError('');
    try {
      await onSave(buildBody(form));
      onClose();
    } catch (e) {
      setError('Create failed: ' + e.message);
    }
    setSaving(false);
  };

  // Close on Escape key
useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') onClose();
  };
  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}, [onClose]);

  return (
    <div style={S.overlay}>
      <div style={S.box} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={S.title}>Add New Video</div>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              background: 'transparent', border: 'none', cursor: 'pointer',
              fontSize: 18, lineHeight: 1, color: colors.textMuted,
              padding: 4, borderRadius: 6,
            }}
          >
            ✕
          </button>
        </div>

        <VideoForm form={form} onChange={handleChange} />

        {error && <div style={field.error}>{error}</div>}

        <div style={S.footer}>
          <button
            onClick={onClose}
            style={{ ...btn.base, ...btn.ghost }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            style={{ ...btn.base, ...btn.primary, opacity: saving ? 0.5 : 1 }}
          >
            {saving ? 'Saving...' : 'Create Video'}
          </button>
        </div>
      </div>
    </div>
  );
}
